import React, {Component} from 'react'
import Jumbotron from '../components/Jumbotron'
import DemoContents from '../components/DemoContents'

class OnSelect extends Component {
  state = {
    iFrame: ''
  }

  onChange = event => {
    this.setState({[event.target.name]: event.target.value})
  }

  render () {
    const {iFrame} = this.state
    return (
      <div>
        <Jumbotron
          variant="dark"
          type="playOnDemand"
          message="gameLoadsAfterAnEvent2"
          showSelect
          selected={iFrame}
          onChange={this.onChange}
        />
        <DemoContents
          variant="light"
          iFrameContents={iFrame && window.amigoGames[iFrame](true)}
        />
      </div>
    )
  }
}

export default OnSelect



// WEBPACK FOOTER //
// ./src/pages/OnSelect.js